module.exports = __webpack_public_path__ + "img/ibkr.5e609a42.png";